import { Directive, ElementRef, HostBinding, OnInit } from '@angular/core';
import { randomString } from '@salesrun/random';

@Directive({
    selector: '[srpNoAutocomplete]',
    standalone: false,
})
export class NoAutocompleteDirective implements OnInit {
    private _prefix: string;

    @HostBinding('attr.name') name: string;
    @HostBinding('attr.autocomplete') autocomplete = 'new-password';

    constructor(private _element: ElementRef<HTMLElement>) { }

    ngOnInit(): void {
        this._prefix = this._element?.nativeElement.getAttribute('name') ?? 'no-autocomplete';
        this.updateName();
    }
    private updateName(): void {
        this.name = randomString({ prefix: `${this._prefix}-` });
    }
}
